import LabelBenchmarkIcon from "./LabelBenchmarkIcon";
export default LabelBenchmarkIcon;